//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Sync = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Sync"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21705_3715)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.24355 1.66167C8.25432 1.6615 8.265 1.66133 8.27567 1.66133L8.27565 1.66119C11.7409 1.66119 14.5507 4.47025 14.5507 7.9362C14.5507 9.51327 13.968 10.955 13.0076 12.0571L11.825 11.0113C12.5389 10.1869 12.9715 9.11194 12.9715 7.93624C12.9715 5.34246 10.8695 3.24042 8.27569 3.24042C8.25347 3.24042 8.23194 3.24042 8.21041 3.24112L8.21111 4.9307L5.74586 2.46546L8.2104 0.000213623V1.66203C8.2216 1.66203 8.23262 1.66185 8.24355 1.66167ZM3.57986 7.93635C3.57986 10.5077 5.64723 12.5953 8.21043 12.63L8.21047 11.0704L10.6757 13.5357L8.21047 16.0002L8.20977 14.2093C4.77422 14.1746 2 11.3801 2 7.9364C2 6.42529 2.53472 5.03912 3.4243 3.95578L4.66389 4.93564C3.98681 5.7495 3.57986 6.79537 3.57986 7.93635Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_21705_3715">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
